/* eslint-disable max-len */
import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
// import ManagerDomain from 'domain/manager';
import StaffDomain from 'domain/staff';
import { getSpecificStaff, getHolidaysOptions } from 'api/staff';
import useRolesOptions from 'hooks/useRoleOptions';
import useBusinessMasterOptions from 'hooks/useBusinessMasterOptions';
import useExecutiveOptions from 'hooks/useExecutiveOptions';
import { OptionType } from 'components/atoms/Select';
import moment from 'moment';
import { getTreesOrgCode } from 'api/organization';

import { getEmploymentSelectListYm } from 'api/employment';
import { fetchBreakUUID } from 'api/shiftPattern';
import ShiftPatternDomain from 'domain/master/attend/shiftPattern';
import { getListICCardByStaff, postRegisterStaffBulkICCard } from 'api/iCCard';

interface holidayType {
  holidayId: string,
  holidayType: number, 
  holidayTypeStr: string,
  holidayCode: string,
  holidayName: string
}

export const useStaffEdit = () => {
  const { staffCode } = useParams<{ staffCode: string }>();
  const [staffDomain, setStaffDomain] = useState<StaffDomain>(StaffDomain.generateInitial());
  const [orgTreeOptions, setOrgTreeOptions] = useState<Array<OptionType>>([]);
  const [holidayOptions, setHolidayOptions] = useState<Array<OptionType>>([]);
  const [holidayTypeOptions, setHolidayTypeOptions] = useState<Array<holidayType>>([]);

  const [employmentOptions, setEmploymentOptions] = useState<Array<OptionType>>([]);
  const [orgTargetDate, setOrgTargetDate] = useState<Date>(new Date());
  const [empTargetDate, setEmpTargetDate] = useState<Date>(new Date());
  const [breakBusiness, setBreakBusiness] = useState<ShiftPatternDomain>(ShiftPatternDomain.generateInitial());
  const [isLoading, setIsLoading] = useState(false);
  const {
    hqRoleOptions, shopRoleOptions, personalRoleOptions, roleOptions,
  } = useRolesOptions();
  const businessOptions = useBusinessMasterOptions();
  const executiveOptions = useExecutiveOptions();
  const trialPeriodOptions: Array<any> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => ({
    value: item.toString(),
    label: item === 0 ? 'なし' : `${item}ヶ月`,
  }));

  useEffect(() => {
    setIsLoading(true);
    if (staffCode) {
      const fetchData = async () => {
        const staffResult = await getSpecificStaff(staffCode);
        const staffDomainResult = new StaffDomain(staffResult);
        getListICCardByStaff(
          staffCode || ""
        ).then((response: any) => {
          staffDomainResult.icCardListData = response.map((card: any) => {
            return {
              cardId: card.cardId
            }
          });
          setIsLoading!(false);
        })
        .catch((error: any) => {
          setIsLoading!(false);
        });
        setStaffDomain(staffDomainResult);
        setOrgTargetDate(staffDomainResult.hireDate!);
        setEmpTargetDate(staffDomainResult.empApplyDate!);
      };
      fetchData();
    }
  }, [staffCode]);

  useEffect(() => {
    fetchBreakUUID().then((response: ShiftPatternDomain) => {
      sessionStorage.setItem('breakTimeBusinessId', response.businessId);
      setBreakBusiness(response);
    });
  }, []);

  useEffect(() => {
    getTreesOrgCode(undefined, undefined, true).then((trees) => {
      const treesOrg = trees.map((tree) => ({
        value: tree.orgCode,
        label: `${tree.orgCode} ${tree.orgName}`,
      }));
      treesOrg.unshift({
        value: '',
        label: '-',
      });

      if (!treesOrg.map((item) => item.value).includes(staffDomain.orgCode) && staffDomain.orgCode) {
        const newStaff = staffDomain.getRawData();
        newStaff.orgCode = treesOrg.length > 1 ? treesOrg[1].value : '';
        setStaffDomain(new StaffDomain(newStaff));
      }
      setOrgTreeOptions(treesOrg);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgTargetDate]);

  useEffect(() => {
    getHolidaysOptions().then((holidays) => {
      const holidayOption = holidays.map((holiday: any) => ({
        value: holiday.holidayId,
        label: `${holiday.holidayName}`,
      }));

      const holidayTypeOption = holidays.map((holiday: any) => ({
        holidayType: holiday.holidayType,
        holidayId: `${holiday.holidayId}`,
        holidayTypeStr: holiday.holidayTypeStr,
        holidayCode: holiday.holidayCode,
        holidayName: holiday.holidayName
      }));

      holidayOption.unshift({
        value: '',
        label: '-',
      });
      
      setHolidayTypeOptions(holidayTypeOption);
      setHolidayOptions(holidayOption);
    });
  }, [])

  useEffect(() => {
    getEmploymentSelectListYm(empTargetDate).then((employments) => {
      const employmentO = employments.map((employment) => ({
        value: employment.employmentId,
        label: `${employment.employmentCode} ${employment.employmentName}`,
      }));
      employmentO.unshift({
        value: '',
        label: '-',
      });
      if (!employmentO.map((item) => item.value).includes(staffDomain.employmentId)) {
        const newStaff = staffDomain.getRawData();
        newStaff.employmentId = '';
        setStaffDomain(new StaffDomain(newStaff));
      }
      setEmploymentOptions(employmentO);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empTargetDate]);

  return {
    isLoading,
    staffDomain,
    setStaffDomain,
    hqRoleOptions,
    shopRoleOptions,
    personalRoleOptions,
    roleOptions,
    businessOptions,
    trialPeriodOptions,
    employmentOptions,
    executiveOptions,
    orgTreeOptions,
    setOrgTargetDate,
    setEmpTargetDate,
    breakBusiness,
    setIsLoading,
    holidayOptions,
    holidayTypeOptions
  };
};

export default useStaffEdit;
